function toggleIngredients(el) {
    let heading = $(el).data('heading');
    $(".cls-ingredients-text").removeClass('active');
    $(el).addClass('active');
    $(".cls-ingredients-content").hide();
    $(".ingredients-" + heading).show();
}

$(".cls-ingredients-text").on("click mouseenter", function () {
    toggleIngredients(this);
});


$(function () {
  
  $(".trigger-add-to-cart").on("click", function (event) {
    event.preventDefault();
    $(".product__info-container .product-form__submit").trigger('click');
  });

  $(".image-text-tabs__heading").on("click", function () {
    const $parent = $(this).closest(".image-text-tabs-content");
    const index = $(this).data("index");

    $(".image-text-tabs__heading").removeClass("active");
    $(this).addClass("active");

    $parent.find(".image-text-tabs__block").hide();
    $parent.find(".image-text-tabs__block-" + index).show();
  });

  $(".collection-tabs li").click(function(){
    const id = $(this).data('id');
    const $slider = $("#Slider-" + id);
    const $parent = $(this).closest('.antr--collection-tabs');

    $slider.parents('.collection').find(".contains-card").removeClass('active');
    $slider.addClass('active');

    $parent.find(".collection-tabs li").removeClass('active');
    $(this).addClass('active');
  
    $parent.find(".contains-card--product").hide().css('opacity', 0);
    
    $slider.show().slick('refresh');

    setTimeout(() => $slider.css('opacity', 1), 500);
  });

  $(".items-card-tab-heading-card").on("click", function (event) {
    event.preventDefault()
    let item = $(this).data('item');
    $(this).siblings(".items-card-tab-heading-card").removeClass("active");
    $(this).addClass("active");
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blocks').hide();
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blockss').hide();
    $(".items-card-tabs__blocks-"+item).show().slick('refresh');
    $(".items-card-tabs__blockss-"+item).show().slick('refresh');
  });

  $(".items-card-tab-heading-book").on("click", function (event) {
    event.preventDefault();
    let item = $(this).data("item");

    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?tab=" + item;
    window.history.pushState({ tab: item }, "", newUrl);

    $(this).siblings(".items-card-tab-heading-book").removeClass("active");
    $(this).addClass("active");

    // ẩn/hiện block
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blocks").hide();
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blockss").hide();
    $(".items-card-tabs__blocks-" + item).show();
    $(".items-card-tabs__blockss-" + item).show();
  });

  $(document).ready(function () {
    let params = new URLSearchParams(window.location.search);
    let tab = params.get("tab");
    let box = params.get("box");

    if (tab) {
      $(".items-card-tab-heading-book[data-item='" + tab + "']")
        .addClass("active")
        .siblings(".items-card-tab-heading-book").removeClass("active");

      $(".items-card-tabs__blocks, .items-card-tabs__blockss").hide();
      $(".items-card-tabs__blocks-" + tab).show();
      $(".items-card-tabs__blockss-" + tab).show();
    }

    if (box) {
      let target = $("#" + box);
      if (target.length) {
        target.addClass("active");

        $("html, body").animate({
          scrollTop: target.offset().top - 100
        }, 600);
      }
    }
  });


  $(".collapsibles_tab .product__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });

  $(".footer-type-link_list .footer-block__heading").click(function () {
    const $parent = $(this).closest(".footer-type-link_list");
    const $content = $parent.find(".footer-block__details-content");

    $(".footer-type-link_list").not($parent).removeClass("active")
      .find(".footer-block__details-content").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });
  
});


$(document)
  .off("click", ".cls-filter-by-concern")
  .on("click", ".cls-filter-by-concern", function () {
    let $content = $(this).parent().find(".image-text-tabs-left");

    $(this).toggleClass("active");
    $content.slideToggle();
  });



document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".animation-number");

  // Lưu giá trị gốc để còn reset khi ra khỏi viewport
  counters.forEach((el) => (el.dataset.raw = el.textContent.trim()));

  const animateNumber = (el, target, formatFn, onDone) => {
    const duration = 2000;
    const startTime = performance.now();

    const step = (t) => {
      const progress = Math.min((t - startTime) / duration, 1);
      const value = progress * target;
      el.textContent = formatFn(value);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatFn(target); // kết thúc chính xác
        if (onDone) onDone();
      }
    };

    requestAnimationFrame(step);
  };

  const parseFormat = (raw) => {
    const match = raw.match(/^([\d.]+)([a-zA-Z%+]+)?$/);
    if (!match) return null;

    let num = parseFloat(match[1]);
    let suffix = (match[2] || "").toUpperCase();
    let target = num;
    let formatFn;

    if (suffix === "K+" || suffix === "K") {
      target = num * 1000;
      formatFn = (val) => Math.floor(val / 1000) + "K+";
    } else if (suffix === "M+" || suffix === "M") {
      target = num * 1000000;
      formatFn = (val) => Math.floor(val / 1000000) + "M+";
    } else if (suffix === "%") {
      formatFn = (val) => Math.floor(val) + "%";
    } else if (suffix === "X") {
      formatFn = (val) => val.toFixed(1) + "X";
    } else {
      formatFn = (val) => Math.floor(val) + suffix;
    }

    return { target, formatFn };
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const raw = el.dataset.raw;

        if (!raw) return;

        if (entry.isIntersecting) {
          if (el.dataset.animating === "1") return;

          const parsed = parseFormat(raw);
          if (!parsed) return;

          el.dataset.animating = "1";
          animateNumber(el, parsed.target, parsed.formatFn, () => {
            el.dataset.animating = "0";
          });
        } else {
          el.textContent = raw;
          el.dataset.animating = "0";
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((counter) => observer.observe(counter));
});


$(document).ready(function() {
  var originalText = $('#color-tag b').text(); // Store the original color text

  $('.recommended_products a').hover(function() {
    var hoverText = $(this).find('img').attr('alt');
    if (hoverText) {
      $('#color-tag b').text(hoverText);
    }
  }, function() {
    $('#color-tag b').text(originalText); // Restore on mouseout
  });
});


// window.initYouMayAlsoLikeSlider = function () {
//   const $slider = $('.you-may-also-like');

//   if (!$slider.length) return;

//   if ($slider.hasClass('slick-initialized')) {
//     $slider.slick('unslick');
//   }

//   $slider.slick({
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 989,
//         settings: { slidesToShow: 2 }
//       },
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 2,
//           arrows: false,
//           dots: true
//         }
//       }
//     ]
//   });
// };

document.addEventListener('DOMContentLoaded', function () {
  initYouMayAlsoLikeSlider();
});
